/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Pagination_PreviousInputs */

const en_audit_pagination_previous = /** @type {(inputs: Audit_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prev`)
};

const pt_br2_audit_pagination_previous = /** @type {(inputs: Audit_Pagination_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anterior`)
};

/**
* | output |
* | --- |
* | "Prev" |
*
* @param {Audit_Pagination_PreviousInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_pagination_previous = /** @type {((inputs?: Audit_Pagination_PreviousInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Pagination_PreviousInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_pagination_previous(inputs)
	return pt_br2_audit_pagination_previous(inputs)
});